<template>
  <div class="pickup-card">
    <div class="pickup-card-head">
      <p class="pickup-card-title">{{ $t('kachogawaPickupOverview.pivot.title') }}</p>
    </div>
    <div class="pickup-card-body">
      <BaseTable
        :data="rows"
        show-summary
        :summary-method="getSummaries"
      >
        <BaseElTableColumn
          :label="$t('kachogawaPickupOverview.pivot.category.title')"
          min-width="140"
        >
          <template #default="{ row }">
            {{ row.categoryName || $t('kachogawaPickupOverview.pivot.uncategorized.title') }}
          </template>
        </BaseElTableColumn>

        <BaseElTableColumn
          v-for="(service, colIndex) in services"
          :key="service.serviceId"
          :label="service.serviceName"
          align="right"
          min-width="90"
        >
          <template #default="{ row }">
            {{ getPrepareCount(row, colIndex) }}
          </template>
        </BaseElTableColumn>

        <BaseElTableColumn
          :label="$t('kachogawaPickupOverview.pivot.subtotal.title')"
          fixed="right"
          align="right"
          width="70"
        >
          <template #default="{ row }">
            <span class="col-total">{{ row.subtotalPrepareCount }}</span>
          </template>
        </BaseElTableColumn>
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { get } from 'lodash'
import { i18n } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'PickupPivotTable',
  props: {
    services: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    totalPrepareCount: {
      type: Number,
      default: 0,
    },
  },
  setup (props) {
    const getPrepareCount = (row, colIndex) => {
      return get(row, `cells[${colIndex}].prepareCount`, 0)
    }

    // el-table 合計列：依欄位順序回傳 [分類, ...各服務總計, 小計總計]
    const getSummaries = ({ columns }) => {
      return columns.map((column, index) => {
        if (index === 0) return i18n.t('kachogawaPickupOverview.pivot.grandTotal.title')
        if (index === columns.length - 1) return props.totalPrepareCount
        return get(props.services, `[${index - 1}].prepareCount`, 0)
      })
    }

    return { getPrepareCount, getSummaries }
  },
})
</script>

<style lang="postcss" scoped>
.pickup-card {
  @apply bg-white border border-gray-40 rounded-md overflow-hidden;
}

.pickup-card-head {
  @apply px-[20px] py-[16px] border-b border-gray-40;
}

.pickup-card-title {
  @apply text-normal font-bold text-gray-100;
}

.pickup-card-body {
  @apply p-[20px];
}

.col-total {
  @apply font-bold text-primary-100;
}

/* 全站 el-table 表頭預設為深色 primary-100；此卡片改回原 pivot 的淺色 primary-10 + 灰字 */
:deep(.el-table th) {
  @apply bg-primary-10;
}

:deep(.el-table th .cell) {
  @apply text-gray-60 font-medium;
}
</style>
